import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
  localeAtom,
  type SupportedLocale,
} from '@/i18n'
import { useLingui } from '@lingui/react/macro'
import { useAtom } from 'jotai'
import { Languages } from 'lucide-react'

const LanguageSelector = () => {
  const { t } = useLingui()
  const [locale, setLocale] = useAtom(localeAtom)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={t`Select language`}
          className="inline-flex items-center justify-center h-9 w-9 border rounded-full cursor-pointer hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Languages size={16} strokeWidth={1.5} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <DropdownMenuRadioGroup
          value={locale}
          onValueChange={(value) => setLocale(value as SupportedLocale)}
        >
          {SUPPORTED_LOCALES.map((supported) => (
            <DropdownMenuRadioItem
              key={supported}
              value={supported}
              className="cursor-pointer"
            >
              {LOCALE_LABELS[supported]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default LanguageSelector
